import React, { type PropsWithChildren, type ReactNode } from 'react';

import clsx from 'clsx';

import styles from './styles.module.css';

type Props = PropsWithChildren<{
  onClick: () => void;
  variant?: 'default' | 'light';
  isActive?: boolean;
  noMargin?: boolean;
  icon?: ReactNode;
  ariaPressed?: boolean;
  ariaLabel?: string;
  overrideClassname?: string;
}>;

export function Pill({
  onClick,
  children,
  isActive = false,
  noMargin = false,
  variant = 'default',
  icon,
  ariaPressed = false,
  ariaLabel,
  overrideClassname,
}: Props) {
  return (
    <button
      aria-label={ariaLabel}
      aria-pressed={ariaPressed ? 'true' : 'false'}
      className={clsx(styles.pill, overrideClassname, {
        [styles.pillActive]: isActive,
        [styles.pillNoMargin]: noMargin,
        [styles.pillLight]: variant === 'light',
      })}
      onClick={onClick}
    >
      {icon && icon}
      {children}
    </button>
  );
}
